<template>
    <div>
        <b-card class="text-primary">
            <b-row>
                <b-col v-if="paciente">
                    <span>Paciente: <h6 class="text-dark">{{ paciente }}</h6></span>

                </b-col>
            </b-row>
            <b-row>
                <b-col v-if="procedimiento">
                    <span>Procedimiento: <h6 class="text-dark">{{ procedimiento }}</h6></span>

                </b-col>
            </b-row>
            <b-row>

                <b-col v-if="medicoRealiza">
                    <span>Medico que realiza el procedimiento: <h6 class="text-dark">{{ medicoRealiza.text }}</h6>
                    </span>

                </b-col>
                <b-col v-if="medicoRealiza">
                    <span>Especialidad del medico: <h6 class="text-dark">{{ medicoRealiza.especialidad }}</h6></span>

                </b-col>
            </b-row>
        </b-card>
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-success"
            active-tab-class="font-weight-bold text-success">
            <b-tab title="Reposo Médico">
                <b-card>
                    <b-row>
                        <b-col cols="6">
                            <span>Dias de descanso:</span>
                            <b-form-input v-model="reposo.diasDescanso" @keypress="soloNumeros"></b-form-input>
                        </b-col>
                        <b-col cols="6">
                            <span>Tipo de contingencia:</span>
                            <b-form-select v-model="reposo.tipoContingencia"
                                :options="optionsContigencia"></b-form-select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-1">
                        <b-col cols="6">
                            <span>Empresa:</span>
                            <b-form-input v-model="reposo.empresa"></b-form-input>
                        </b-col>
                        <b-col cols="6">
                            <span>Ocupación:</span>
                            <b-form-input v-model="reposo.ocupacion"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-1">
                        <b-col cols="6">
                            <span>Aislamiento:</span>
                            <b-form-select :options="optionsAislamiento" v-model="reposo.aislamiento"></b-form-select>
                        </b-col>
                        <b-col cols="6">
                            <span>Direccion:</span>
                            <b-form-input v-model="reposo.direccion"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-1">
                        <b-col cols="12">
                            <span>Observaciones:</span>
                            <b-form-textarea placeholder="Coloque las recomendaciones que debera seguir"
                                v-model="reposo.observaciones"></b-form-textarea>
                        </b-col>
                    </b-row>
                    <hr />
                    <span>Diagnostico (principal):</span>
                    <b-row class="d-flex align-items-center mt-1">

                        <SearchOpts v-model="searchDiagnostico" :searchService="diagnosticosService.getByQuerySelect"
                            :minChars="3" :placeholder="'Buscar diagnostico...'" class="col-7" />

                        <b-col cols="3">
                            <b-form-radio-group id="diags-radio-group" v-model="tipoDiagnostico"
                                :options="['definitivo', 'presuntivo']" />
                        </b-col>
                        <b-col cols="2">
                            <b-button variant="warning" @click="agregarDiagnostico" size="sm">
                                <i class="fa-solid fa-plus" />
                            </b-button>
                        </b-col>

                        <b-col v-if="reposo.diagnosticosList.length" class="mt-1" cols="12">
                            <b-table small :items="reposo.diagnosticosList" :fields="fields">

                                <template #cell(acciones)="data">
                                    <b-button @click="eliminarRegistro(data.index)" variant="danger" size="sm">
                                        <i class="fa-solid fa-trash"></i>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>

                    <hr />

                </b-card>
                <div class="text-right my-2">
                    <b-button variant="primary" class="mr-2" @click="onSaveReposo">
                        Guardar
                    </b-button>


                </div>
            </b-tab>
            <b-tab title="Descargas">
                <b-card class="p-4 m-4">
                    <b-row class="text-center">
                        <b-col v-if="tokenFormulario">
                            <b-button @click="obtenerDescansoMedicoProcedimiento" variant="success" size="xl">
                                <div>
                                    <i class="fa-solid fa-3x fa-bed"></i>
                                </div>
                                <div class="mt-1">
                                    <h4 class="text-white">Certificado de Descanso</h4>
                                </div>
                            </b-button>
                        </b-col>
                        <b-col>
                            <b-button @click="obtenerAsistenciaProcedimiento" variant="info" size="xl">
                                <div>
                                    <i class="fa-solid fa-3x fa-door-open"></i>
                                </div>
                                <div class="mt-1">
                                    <h4 class="text-white">Certificado de Asistencia</h4>
                                </div>
                            </b-button>
                        </b-col>

                    </b-row>

                </b-card>
            </b-tab>



        </b-tabs>





    </div>

</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { SearchOpts, ModalContainer } from "@/shared/components";
import { doctoresService, auxiliarService } from "@/shared/services";
import { diagnosticosService } from "../../../atencionMedica/services";
import { procedimientosFormulariosService, procedimientosService } from "../../services";
import vSelect from "vue-select";
import actions from '../../../../assets/utils/utils';


export default {
    components: {
        flatPickr,
        SearchOpts,
        ModalContainer,
        VueTimepicker,
        vSelect
    },

    props: {
        medicoRealiza: {
            default: null,
            required: false
        },
        paciente: {
            default: null,
            required: false
        },
        procedimiento: {
            default: null,
            required: false
        },
        tokenProceso: {
            default: null,
            required: false
        }
    },

    data() {
        return {
            tipoDiagnostico: null,
            searchMedico: null,
            dataProceso: null,
            idRegistroForm: null,
            selectedTipoDiagnostico: null,
            messageAlert: null,
            optionsContigencia: [
                'Enfermedad General', 'Accidente Común', 'Enfermedad Profesional', 'Accidente de Trabajo', 'Maternidad o Paternidad', 'Riesgo durante el embarazo o la lactancia', 'Intervenciones Quirurgicas'
            ],
            optionsAislamiento: ['Aislamiento', 'Teletrabajo', 'Ninguno'],
            reposo: {
                diasDescanso: null,
                direccion:null,
                tipoContingencia: 'Intervenciones Quirurgicas',
                empresa: null,
                ocupacion: null,
                observaciones: null,
                aislamiento: 'Ninguno',
                diagnosticosList: [],
            },
            searchDiagnostico: null,
            diagnosticosService,
            procedimientosService,
            idProcActual: null,
            doctoresService,
            doctor: null,
            fechaActual: null,
            horaActual: null,

            birthDateConfig: {
                allowInput: true,
                dateFormat: "Y-m-d", // Solo fecha
            },

            fields: [

                {
                    key: "diagnostico",
                    label: "Diagnostico",
                    sortable: true,
                    thClass: "text-center small-column",
                    tdClass: "small-column",
                },
                {
                    key: "tipoDiagnostico",
                    label: "tipoDiagnostico",
                    sortable: true,
                    thClass: "text-center small-column",
                    tdClass: "small-column",
                },
                {
                    key: "acciones",
                    label: "",
                    sortable: true,
                    thClass: "text-center small-column",
                    tdClass: "small-column",
                },
            ],

            fieldsProcedimientos: [



                {
                    key: "procedimiento",
                    label: "Procedimiento",
                    sortable: true,
                    thClass: "text-center small-column",
                    tdClass: "small-column",
                },

                {
                    key: "acciones",
                    label: "",
                    sortable: true,
                    thClass: "text-center small-column",
                    tdClass: "small-column",
                },
            ],

        };
    },
    created() {

        this.setDate();
        this.loadData();

   

    },

    methods: {
        soloNumeros(e) {
            if (!/[\d]/.test(e.key)) {
                e.preventDefault();
            }
            if (this.reposo.diasDescanso && this.reposo.diasDescanso.length === 2) {
                e.preventDefault()
            }
        },

        async obtenerDescansoMedicoProcedimiento(){
            console.log("token formulario", this.tokenFormulario)
            const pdf_file = await procedimientosFormulariosService.obtenerDescansoMedicoProc(this.tokenFormulario)
            
        
            let name_paciente = ''
            if (this.paciente) { name_paciente = this.paciente }
            
            actions.cargarArchivos(
                      pdf_file,
                       name_paciente + "_descanso_procedimiento" + ".pdf",
                      "data:application/pdf;base64"
                    );
         
              
        },

        async obtenerAsistenciaProcedimiento(){
            
            const pdf_file = await procedimientosService.obtenerAsistenciaProc(this.tokenProceso)
            
            let name_paciente = ''
            if (this.paciente) { name_paciente = this.paciente }
            
            actions.cargarArchivos(
                      pdf_file,
                       name_paciente + "_asistencia_procedimiento" + ".pdf",
                      "data:application/pdf;base64"
                    );
         
              
        },


        async loadData() {
            // this.reposo = {

            //     fechaElaboracion: null,
            //     dirigidoA: "SEÑORES DEPARTAMENTO DE DERIVACIONES SUBDIRECCION PROVINCIAL DE PRESTACIONES DE SALUD IESS GUAYAS",
            //     codigoValidacion: null,
            //     fechaAtencion: null,
            //     procedimientosList: [],
            //     diagnosticosList: [],
            //     medicoSolicitante: null,
            //     cuadroClinico: null,
            //     especialidadDeriva: null,
            //     observaciones: null,
            //     codigoTarifario: null,
            //     nivelDeriva: null,


            // },

            this.dataProceso = null;
            this.idRegistroForm = null

            const responseGet = await procedimientosFormulariosService.getByProceso(this.tokenProceso, 'rep');
            

            try {
                if (responseGet.data && responseGet.data.length > 0) {
                    const reposo = JSON.parse(responseGet.data[0].dataJson)
                    this.reposo = reposo
                    this.tokenFormulario = responseGet.data[0].token
                }

            } catch (error) { console.log("error", error) }



        },

        setDate() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
            const day = String(now.getDate()).padStart(2, "0");
            this.fechaActual = `${year}-${month}-${day}`;
            this.horaActual = now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2);
        },


        eliminarRegistro(index) {
            this.reposo.diagnosticosList.splice(index, 1);


        },
        eliminarRegistroProcedimiento(index) {
            this.informe.procedimientosList.splice(index, 1);

        },


        eliminarMedico(index) {
            this.informe.tableMedicos.splice(index, 1);
        },

        agregarProcedimiento() {
            if (!this.searchProcedimiento) {
                this.$swal.fire({
                    icon: "info",
                    text: "Ingrese el procedimiento",
                });
                return;
            }

            this.informe.procedimientosList.push({
                procedimiento: this.searchProcedimiento.text,
                procObject: this.searchProcedimiento,

            });

            this.searchProcedimiento = null;

        },


        agregarDiagnostico() {


            const dataTable = this.reposo.diagnosticosList;

            if (dataTable && dataTable.length > 0) {
                this.$swal.fire({
                    icon: "info",
                    text: "Ya existe un diagnostico agregado, debe eliminar el existente",
                });
                this.searchDiagnostico = null;
                this.tipoDiagnostico = null;
                return;
            }



            this.reposo.diagnosticosList.push({
                diagnostico: this.searchDiagnostico.text,
                tipoDiagnostico: this.tipoDiagnostico,
                diagObject: this.searchDiagnostico
            });

            this.searchDiagnostico = null;
            this.tipoDiagnostico = null;


        },


        async onSaveReposo() {

            const params = {
                nameForm: "rep",
                dataJson: JSON.stringify(this.reposo),
                tokenProceso: this.tokenProceso,
                tokenFormulario: this.tokenFormulario,

            };

            const responseSave = await procedimientosFormulariosService.guardarData(params);

            if (!responseSave) {
                this.$swal({
                    title: "Error",
                    text: "No se guardo! Contacte al equipo de desarrollo",
                    icon: "error",
                    confirmButtonColor: "#089599",
                });

                return;
            }

            await this.$swal.fire({
                icon: "success",
                text: "Guardado correctamente",
            });

            this.$router.go(0)


        },
    },

    watch: {


        '$route.query.finf': {
            handler(newValue) {
                if (newValue) { this.loadData() }

            },
        },
    }

};
</script>

<style scoped>
.flatpickr-input {
    font-size: 0.85rem;
    padding: 0.25rem 0.5rem;
}

.parpadeo {
    font-weight: 200;
}
</style>
